import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSportsbookDefaultOddsFormat } from '../../../brand/ducks/selectors';
import { OddsFormat } from '../sportsbook-types';
import { selectOddsFormat, updateOddsFormat } from '~/components/sportsbook/lobby/sportsbook-configuration-duck';
import { AppDispatch } from '~/store/types';

const useOddsFormat = (): { oddsFormat: OddsFormat; setOddsFormat: (oddsFormat: OddsFormat) => void } => {
	const dispatch: AppDispatch = useDispatch();
	const defaultOddsFormat = useSelector(selectSportsbookDefaultOddsFormat);
	const preferredOddsFormat = useSelector(selectOddsFormat);

	const changeOddsFormat = useCallback(
		(oddsFormatToChange: OddsFormat) => {
			dispatch(updateOddsFormat(oddsFormatToChange));
		},
		[dispatch]
	);

	const oddsFormat = useMemo(() => {
		if (
			preferredOddsFormat &&
			Object.values<string>(OddsFormat).some((val: string) => val === preferredOddsFormat)
		) {
			return preferredOddsFormat as OddsFormat;
		}
		return defaultOddsFormat;
	}, [defaultOddsFormat, preferredOddsFormat]);

	return {
		oddsFormat,
		setOddsFormat: changeOddsFormat
	};
};

export default useOddsFormat;
